var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{staticClass:"custom-input-number",attrs:{"id":"custom-input-number-1","min":_vm.min,"step":_vm.step,"disabled":_vm.disabled,"size":"mini"},on:{"change":_vm.debouncedMethod},model:{value:(_vm.num),callback:function ($$v) {_vm.num=$$v},expression:"num"}})
}
var staticRenderFns = []

export { render, staticRenderFns }